import { UseFormRegister, FieldErrors, Path, FieldValues } from "react-hook-form"
import { Label } from "@/components/chadcn/Label"
import { TextareaInput, TextInput } from "@/components/InputFields"

type MealLogCompatible = {
  mealContents?: string
  carbsInGrams?: number
  proteinInGrams?: number
}

type MealLogProps<T extends FieldValues & MealLogCompatible> = {
  register: UseFormRegister<T>
  errors: FieldErrors<MealLogCompatible>
  disabled?: boolean
}

const MealLog = <T extends FieldValues & MealLogCompatible>({
  register,
  errors,
  disabled,
}: MealLogProps<T>) => (
  <div className="flex flex-col gap-4">
    <div className="flex flex-col gap-1">
      <Label htmlFor="mealContents">What did you eat? (optional)</Label>
      <TextareaInput
        id="mealContents"
        rows={3}
        placeholder="e.g. salad, grilled chicken…"
        disabled={disabled}
        isError={!!errors.mealContents}
        {...register("mealContents" as Path<T>)}
      />
      {errors.mealContents && (
        <p className="text-sm text-error">{errors.mealContents.message}</p>
      )}
    </div>

    <div className="flex gap-4">
      <div className="flex flex-1 flex-col gap-1">
        <Label htmlFor="carbsInGrams">Carbs (g, optional)</Label>
        <TextInput
          id="carbsInGrams"
          type="number"
          min={0}
          max={1000}
          step={1}
          disabled={disabled}
          isError={!!errors.carbsInGrams}
          {...register("carbsInGrams" as Path<T>, { valueAsNumber: true })}
        />
        {errors.carbsInGrams && (
          <p className="text-sm text-error">{errors.carbsInGrams.message}</p>
        )}
      </div>

      <div className="flex flex-1 flex-col gap-1">
        <Label htmlFor="proteinInGrams">Protein (g, optional)</Label>
        <TextInput
          id="proteinInGrams"
          type="number"
          min={0}
          max={1000}
          step={1}
          disabled={disabled}
          isError={!!errors.proteinInGrams}
          {...register("proteinInGrams" as Path<T>, { valueAsNumber: true })}
        />
        {errors.proteinInGrams && (
          <p className="text-sm text-error">{errors.proteinInGrams.message}</p>
        )}
      </div>
    </div>
  </div>
)

export default MealLog
